<template>
  <div class="container">
    <div class="row">
      <div class="col-md-4 col-md-offset-4">
        <div class="login-panel panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">Авторизация</h3>
          </div>
          <div class="panel-body">
            <form @submit.prevent="submitForm">
              <fieldset>
                <div class="form-group">
                  <input
                    class="form-control"
                    placeholder="Имя пользователя"
                    name="login"
                    type="text"
                    v-model="login"
                    autofocus
                  />
                </div>
                <button
                  type="submit"
                  class="btn btn-success btn-block"
                  :disabled="submitWasDisabled"
                >
                  Войти
                </button>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useNotification } from "@/_shared/mixins";
import apiService from "@/authorization/apiService";
export default {
  mixins: [useNotification],
  data() {
    return {
      login: "",
    };
  },
  computed: {
    submitWasDisabled() {
      return !!(this.login.length === 0);
    },
  },
  methods: {
    async submitForm() {
      try {
        await apiService
          .checkExistence(this.login)
          .then(({ data }) => {
            this.$emit("user-is-exist", data.user);
          })
          .catch(({ response }) => {
            throw new Error(response.data.message);
          });
      } catch (error) {
        this.showErrorNotification(error.message, "Ошибка");
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/authorization/components/LoginForm.vue